var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('SearchProductV2'),_c('SelectedProducts'),_c('ProductsTable'),_c('Edit'),_c('OrderProductStatistics'),_c('EditProductBarcodes')],1)}
var staticRenderFns = []

export { render, staticRenderFns }